const Data = [
    {
        id: 1,
        category: "education",
        icon: "icon-envelope-letter",
        year: "2026-2026",
        title: "Cornell University",
        desc : "I aspire to complete a Masters of Engineering at Cornell through the early admit program",
        
    },
    {
        id: 2,
        category: "education",
        icon: "icon-envelope-letter",
        year: "2022-2026",
        title: "Cornell University",
        desc : "Pursuing a Bachelor's of Science of Computer Science with minors in Operations Research and Business. College of Engineering Dean's List Recipient",
    },
    {
        id: 3,
        category: "education",
        icon: "icon-envelope-letter",
        year: "2018-2022",
        title: "Foothill High School",
        desc : "Athelete for Foothill's Swim Team and Water Polo Team, President of CAYA, Member of Foothill We the People",
    },
    {
        id: 4,
        category: "experience",
        icon: "icon-briefcase",
        year: "2024-Present",
        title: "Software Engineering Intern @ Azure Biosystems",
        desc : "Revitalized the ChemiSOLO product web page with Vue.js",
    },
    {
        id: 5,
        category: "experience",
        icon: "icon-briefcase",
        year: "2024-Present",
        title: "AEW Facilitator for CS 3110",
        desc : "Responsibilities include organize workshops and elucidate concepts",
    },
    {
        id: 6,
        category: "experience",
        icon: "icon-briefcase",
        year: "2023-2024",
        title: "Android Frontend Intern @ FoodCLUB",
        desc : "Working at FoodCLUB as an Android frontend developer intern",
    },
    {
        id: 7,
        category: "experience",
        icon: "icon-briefcase",
        year: "2023-2024",
        title: "ORIE Undergraduate Researcher",
        desc : "Working under Professor Nelson and Professor Henderson to optimize a decentralized approach toward biochar pyrolysis in Kisumu, Kenya",
    },
];
export default Data